import React, { useState, FC } from 'react'

import { CreateToolbar, AsidePreview, EditForm } from '../containers'
import { EditProps, Edit, SimpleForm } from 'react-admin'
import { FormProvider } from 'contexts'

export const EditPerson: FC<EditProps> = (props: any) => {
  const {
    showAside = false,
    shouldRedirect = true,
    closeDrawer = false,
    onSubmitSuccess = () => {},
    onSubmitFailure = () => {},
  } = props

  const [formData, setFormData] = useState([])

  return (
    <>
      <Edit {...props}>
        <SimpleForm>
          <FormProvider>
            <EditForm
                {...props}
                setFormData={setFormData}
                toolbar={<CreateToolbar closeDrawer={closeDrawer} />}
                aside={showAside ? <AsidePreview formData={formData} /> : <></>}
                onSubmitSuccess={onSubmitSuccess}
                onSubmitFailure={onSubmitFailure}
                shouldRedirect={shouldRedirect}
                resource="cms/content/involved_people"
              />
          </FormProvider>
        </SimpleForm>
      </Edit>
    </>
  )
}
